import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

import { StyledCheckoutWrapper } from '@styles/generalStyles';

export const PageWrapper = styled(StyledCheckoutWrapper)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`;

export const StyledFormContainer = styled.div`
  flex-grow: 1;
  margin-bottom: 1rem;
  @media (min-width: ${breakpoints.md}) {
    flex-basis: 49%;
    margin-right: 4.5rem;
  }
`;

export const StyledCartContainer = styled.div`
  flex-grow: 1;
  @media (min-width: ${breakpoints.md}) {
    flex-basis: 42%;
  }
`;
